<template>
  <transition
    enter-active-class="animated fadeIn"
    leave-active-class="animated fadeOut"
  >
    <div v-if="visible" class="modal-wrapper">
      <div
        v-if="assistantInfo"
        v-long-touch="longTouch"
        class="content-wrap"
        :style="{ backgroundImage: `url(${strategyData.assistant_bg})` }"
      >
        <div class="info">
          <img class="avatar" :src="assistantInfo.avatar" alt="" />
          <div>
            <div class="name">
              风变福利官：<span class="highlight">{{
                assistantInfo.name
              }}</span>
            </div>
            <div class="desc">
              派发<span class="highlight">0元课、学习资料</span>等
            </div>
          </div>
        </div>
        <template v-if="!assistantInfo.qr_url">
          <div class="qrcode-wrap unactive" @click="handleGetAssitantInfo">
            <div class="icon-reload" />
          </div>
          <img
            class="icon-touch"
            src="https://res.pandateacher.com/5D65EQY11630920711303.png"
            alt=""
          />
          <div class="tips">点击重新获取吧</div>
        </template>
        <template v-else>
          <div class="qrcode-wrap active">
            <img class="qrcode" :src="assistantInfo.qr_url" alt="" />
          </div>
          <img
            class="icon-touch"
            src="https://res.pandateacher.com/2G55LAR21630920711221.png"
            alt=""
          />
          <div class="tips">长按图片识别二维码添加</div>
        </template>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import toast, { ToastType } from '@/basic/components/Toast';
import Loading from '@/basic/components/Loading';
import { promiseLock } from '@/lib/decorates';
import directive from '@lib/event/long-touch';

Vue.directive('long-touch', directive);

@Component({})
export default class Repay extends Vue {
  @Prop({ type: Boolean }) visible!: false;
  @Prop({}) strategyData!: any;
  @Prop({}) longTouch!: Function;

  data = { assistants: {}, id: 0 };

  @Watch('strategyData')
  updateMyStrategyData(newVal: any) {
    this.data = newVal;
  }

  @Watch('visible')
  shouldGetAssitantInfo(newVal: boolean) {
    newVal && this.handleGetAssitantInfo();
  }

  get assistantInfo() {
    return this.data?.assistants;
  }

  @promiseLock
  handleGetAssitantInfo() {
    Loading.show();

    return window.apis
      .getStrategyAssistantInfo({ strategy: this.data.id })
      .then(({ data }: any) => {
        if (data?.assistants?.qr_url) {
          this.$set(this.data, 'assistants', data?.assistants);
          Loading.close();
        } else {
          Loading.close();

          toast({
            type: ToastType.failure,
            value: '获取失败',
          });
        }
      })
      .catch(() => {
        Loading.close();

        toast({
          type: ToastType.failure,
          value: '获取失败',
        });
      });
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/animation.scss';

.animated {
  animation-duration: 0.4s;
}
.fadeIn {
  animation-name: fadeIn;
}
.fadeOut {
  animation-name: fadeIn;
  animation-direction: reverse;
}
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4;
  display: flex;
  align-items: flex-end;
  // justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
}
.content-wrap {
  width: 750px;
  height: 903px;
  background-size: cover;
}
.info {
  display: flex;
  margin-top: 318px;
  margin-left: 178px;

  .avatar {
    width: 96px;
    height: 96px;
    margin-right: 14px;
    overflow: hidden;
    border-radius: 50%;
  }
  .name {
    margin-top: 20px;
    color: #353535;
    font-weight: bold;
    font-size: 24px;
  }
  .desc {
    color: #353535;
    font-size: 24px;
  }
  .highlight {
    color: rgba(8, 83, 255, 1);
  }
}

.qrcode-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 316px;
  height: 316px;
  margin: 34px auto 0 auto;
  background-size: cover;

  &.active {
    background-image: url(https://res.pandateacher.com/M92PVPXM1630920926879.png);
  }
  &.unactive {
    background-image: url(https://res.pandateacher.com/MZ486BGN1630920926809.png);
  }

  .icon-reload {
    width: 66px;
    height: 66px;
    background-image: url(https://res.pandateacher.com/8LM6XAQY1630920992953.png);
    background-size: cover;
  }
  .qrcode {
    width: 286px;
    height: 286px;
  }
}
.icon-touch {
  width: 46px;
  height: 46px;
  margin: 10px auto;
}
.tips {
  color: #444444;
  font-size: 25px;
  text-align: center;
}
</style>
